import { render, staticRenderFns } from "./MedResultCard.vue?vue&type=template&id=088051a6&scoped=true&"
import script from "./MedResultCard.vue?vue&type=script&lang=js&"
export * from "./MedResultCard.vue?vue&type=script&lang=js&"
import style0 from "./MedResultCard.vue?vue&type=style&index=0&id=088051a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088051a6",
  null
  
)

export default component.exports